import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Button } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

// Sample Data (Replace with API response)
const reviewDocuments = [
  { name: "Form_123.pdf", confidence: 67, reviewNeeded: true },
  { name: "ID_234.png", confidence: 45, reviewNeeded: true },
  { name: "Report_789.docx", confidence: 80, reviewNeeded: false },
  { name: "Invoice_567.jpg", confidence: 55, reviewNeeded: true },
];

// Function to get color-coded confidence score
const getConfidenceChip = (confidence) => {
  if (confidence >= 80) return <Chip label={`${confidence}%`} style={{ backgroundColor: "#00c853", color: "#fff" }} />;
  if (confidence >= 60) return <Chip label={`${confidence}%`} style={{ backgroundColor: "#ffab00", color: "#fff" }} />;
  return <Chip label={`${confidence}%`} style={{ backgroundColor: "#d50000", color: "#fff" }} />;
};

const ManualReviewQueue = () => {
  return (
    <TableContainer component={Paper} style={{ backgroundColor: "#1a1a2e", color: "#00f5d4" }}>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: "#00f5d4" }}>
            <TableCell style={{ color: "#000" }}>Document Name</TableCell>
            <TableCell style={{ color: "#000" }}>AI Confidence</TableCell>
            <TableCell style={{ color: "#000" }}>Review Needed</TableCell>
            <TableCell style={{ color: "#000" }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reviewDocuments.map((doc, index) => (
            <TableRow key={index} style={{ backgroundColor: "#0d1b2a", color: "#00f5d4" }}>
              <TableCell>{doc.name}</TableCell>
              <TableCell>{getConfidenceChip(doc.confidence)}</TableCell>
              <TableCell>
                {doc.reviewNeeded ? (
                  <Chip label="Yes" style={{ backgroundColor: "#ff1744", color: "#fff" }} />
                ) : (
                  <Chip label="No" style={{ backgroundColor: "#00c853", color: "#fff" }} />
                )}
              </TableCell>
              <TableCell>
                {doc.reviewNeeded && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<VisibilityIcon />}
                    style={{ backgroundColor: "#00eaff" }}
                  >
                    Review
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ManualReviewQueue;
